import { initOptions } from './questions.js';
export const defaultStartQuestion = (product) => ({
    stepName: 'start',
    question: 'FeedbackStartStep',
    props: {
        title: 'We ❤️ your feedback!',
        ledeIn: `We hope you enjoyed your ${product === 'group' ? 'group' : '1:1'} conversation!`,
        ledeOut: 'Your feedback will help us make our matches even more impactful.',
    },
});
export const defaultFitQuestion = (product) => ({
    stepName: 'fit',
    question: 'GenericRatingStep',
    props: {
        title: `My ${product === 'group' ? 'group' : 'match'} was a good fit for me`,
        variableName: 'core___match_rating',
        options: [initOptions('1'), initOptions('2'), initOptions('3'), initOptions('4'), initOptions('5')],
        labels: ['Strongly disagree', 'Strongly agree'],
    },
});
export const defaultRecommendQuestion = (product) => ({
    stepName: 'recommend',
    question: 'SpecificNPSStep',
    props: {
        title: `How likely are you to recommend your ${product === 'group' ? 'group' : 'peer'} conversation?`,
        variableName: 'core___nps',
    },
});
export const defaultTestimonialQuestion = (product) => ({
    stepName: 'testimonial',
    question: 'GenericTextStep',
    props: {
        title: 'If you enjoyed or benefitted from this conversation, please leave a brief testimonial',
        ledeIn: `For example: what made this a great ${product === 'group' ? 'group' : 'match'}, any specific takeaways...`,
        placeholder: null,
        variableName: 'core___testimonial',
        variableDefault: null,
        minChars: null,
    },
});
export const defaultDecisionQuestion = () => ({
    stepName: 'decision',
    question: 'SingleSelectStep',
    props: {
        title: 'Do you think this conversation will help you make a better decision in the future?',
        ledeIn: null,
        options: [initOptions('Yes'), initOptions('No')],
        variableName: 'core___decision',
        variableDefault: null,
    },
    lockedProps: ['title', 'ledeIn', 'options'],
});
// export const defaultLikelyCustomerQuestion = (workspaceName: string) => ({
//   stepName: 'likelihood',
//   question: 'SingleSelectStep',
//   props: {
//     title: `Has this matching initiative made you more likely to start or continue being a(n) ${workspaceName} customer?`,
//     ledeIn: null,
//     options: [
//       initOptions('Yes, significantly more likely'),
//       initOptions('Yes, somewhat more likely'),
//       initOptions('No, it has not made a difference'),
//       initOptions('No, it has made me significantly less likely to use your products or services')
//     ],
//     variableName: 'core___likelihood',
//     variableDefault: null,
//   },
//   lockedProps: [],
// });
export const defaultTopicsQuestion = () => ({
    stepName: 'topics',
    question: 'MultiSelectStep',
    isDisabled: true,
    props: {
        title: 'Future Discussion Topics',
        ledeIn: 'Which topics would you be most interested in discussing over future conversations?',
        options: [
            initOptions('Mastering prioritization'),
            initOptions('Tackling tough conversations'),
            initOptions('The future you'),
            initOptions('Giving and receiving mentorship'),
            initOptions('I’d prefer to connect without a specific topic'),
        ],
        variableName: 'core___topics',
        variableDefault: [],
        minSelect: 1,
        other: {
            isEnabled: false,
        },
    },
    lockedProps: ['title'],
});
export const defaultProductQuestion = () => ({
    stepName: 'product',
    question: 'SingleSelectStep',
    isDisabled: true,
    props: {
        title: 'What kind of experiences do you find most valuable?',
        options: [
            initOptions('Curated 1:1 conversations'),
            initOptions('Intimate roundtables of 4-8'),
            initOptions('Webinars and fireside chats'),
            initOptions('Panel events'),
        ],
        variableName: 'preference___product',
        variableDefault: null,
        other: {
            isEnabled: false,
        },
    },
    lockedProps: ['title'],
});
export const defaultFrequencyQuestion = (product) => ({
    stepName: 'frequency',
    question: 'SingleSelectStep',
    isDisabled: true,
    props: {
        title: `How frequently would you like to be matched for ${product === 'group' ? 'group' : '1:1'} connections within the community?`,
        options: [
            initOptions('Weekly'),
            initOptions('Every other week'),
            initOptions('Monthly'),
            initOptions("On a 'need to' basis"),
            initOptions("I don't want to be matched again"),
        ],
        variableName: 'preference___frequency',
        variableDefault: null,
    },
    lockedProps: ['title'],
});
export const defaultReconnectQuestion = (product) => ({
    stepName: 'reconnect',
    question: 'SingleSelectStep',
    isDisabled: product === 'group',
    props: {
        title: 'Would you like us to reconnect the both of you?',
        ledeIn: 'We will not share this with your match unless you both opt-in.',
        options: [
            initOptions('Two months'),
            initOptions('Three months'),
            initOptions('Six months'),
            initOptions("I don't want to get reconnected"),
        ],
        variableName: 'match___reconnect',
        variableDefault: null,
    },
    lockedProps: ['title', 'ledeIn', 'options'],
});
export const defaultInternalUsecase = () => ({
    stepName: 'internal_usecase',
    question: 'SingleSelectStep',
    isDisabled: true,
    props: {
        title: 'Would you like to explore using Orbiit for your own organisation or community?',
        ledeIn: null,
        options: [initOptions("Yes, I'd love to learn more"), initOptions('No thank you')],
        variableName: 'internal_usecase',
        variableDefault: [],
    },
    isLocked: true,
    lockedProps: ['title', 'ledeIn', 'options'],
});
export const defaultAdviceQuestion = () => ({
    stepName: 'advice',
    question: 'GenericTextStep',
    props: {
        title: 'How can we improve the experience?',
        ledeIn: 'Please be honest, we appreciate it!',
        placeholder: null,
        variableName: 'internal___advice',
        variableDefault: null,
        minChars: null,
    },
});
export const defaultDoneQuestion = (product, stepName = 'done') => ({
    stepName: stepName,
    question: 'FeedbackDoneStep',
    props: {
        title: 'Thank you for your time!',
        ledeIn: `Your advice helps us make our ${product === 'group' ? 'group' : '1:1'} conversations more impactful.`,
        formEnabled: false,
    },
});
export const defaultNoChatStartQuestion = () => ({
    stepName: 'no-chat-start',
    question: 'FeedbackStartStep',
    props: {
        title: 'We ❤️ your feedback!',
        ledeIn: null,
        ledeOut: 'Your feedback will help us make these matches even more impactful.',
    },
});
export const defaultNoChatReasonQuestion = (product) => ({
    stepName: 'no-chat-reason',
    question: 'SingleSelectStep',
    props: {
        title: `What was the main reason for the ${product === 'group' ? 'group' : ''} conversation not happening?`,
        options: [
            initOptions('We have rescheduled'),
            initOptions('I did not see the email'),
            initOptions('I could not make the time in the end'),
            initOptions("We didn't find the right date/time"),
            initOptions('We experienced technical issues'),
            initOptions(`My ${product === 'group' ? 'group' : 'match'} did not show up`),
        ],
        variableName: 'internal___reason',
        variableDefault: null,
        other: {
            isEnabled: false,
        },
        randomizeOptions: false,
    },
});
export const defaultNoChatAdviceQuestion = () => ({
    stepName: 'no-chat-advice',
    question: 'GenericTextStep',
    props: {
        title: 'How can we improve our process for you?',
        placeholder: null,
        variableName: 'internal___advice',
        variableDefault: null,
        minChars: null,
    },
});
export const generateDefaultForm = (_, product) => [
    defaultStartQuestion(product),
    defaultFitQuestion(product),
    defaultRecommendQuestion(product),
    defaultTestimonialQuestion(product),
    defaultDecisionQuestion(),
    defaultTopicsQuestion(),
    defaultProductQuestion(),
    defaultFrequencyQuestion(product),
    // Custom questions have to be inserted BETWEEN and frequency and reconnect/internal
    ...(product === 'one-to-one' ? [defaultReconnectQuestion(product)] : []),
    defaultInternalUsecase(),
    defaultAdviceQuestion(),
    defaultDoneQuestion(product),
    // No-Chat Form is appended to the Feedback Questions
    defaultNoChatStartQuestion(),
    defaultNoChatReasonQuestion(product),
    defaultNoChatAdviceQuestion(),
    defaultDoneQuestion(product, 'no-chat-done'),
];
